module.exports = __webpack_public_path__ + "img/bg_avatar_female_31.b467f9c6.png";